import { useRef, useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";
// import AddPipelineModal from "./AddPipelineModal";
import DatePicker from "react-datepicker";
import EditPipelineModal from "./EditPipelineModal";

const EditLeadAddModal = ({ show, handleClose }) => {
  const [showPipeline, setShowPipeline] = useState(false);
  const [tags, setTags] = useState(["Vaughan Lewis"]);
  const [input, setInput] = useState("");

  // Add tag on Enter
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && input.trim() !== "") {
      e.preventDefault();

      // prevent duplicates
      if (!tags.includes(input.trim())) {
        setTags([...tags, input.trim()]);
      }

      setInput("");
    }
  };

  // Remove tag
  const removeTag = (index) => {
    const newTags = tags.filter((_, i) => i !== index);
    setTags(newTags);
  };
  const [projectList, setProjectList] = useState([
    "Office Management",
    "Clinic Management",
  ]);

  const [projectInput, setProjectInput] = useState("");

  // Add new project
  const handleProjectAdd = (e) => {
    if (e.key === "Enter" && projectInput.trim() !== "") {
      e.preventDefault();

      const value = projectInput.trim();

      if (!projectList.includes(value)) {
        setProjectList([...projectList, value]);
      }

      setProjectInput("");
    }
  };

  // Remove project
  const handleProjectRemove = (index) => {
    const updatedList = projectList.filter((_, i) => i !== index);
    setProjectList(updatedList);
  };
  const [dueDate, setDueDate] = useState(null);
  const [closingDate, setClosingDate] = useState(null);

  const dueRef = useRef(null);
  const closingRef = useRef(null);


    const [assigneeList, setAssigneeList] = useState(["Vaughan Lewis"]);
  const [assigneeInput, setAssigneeInput] = useState("");

  // Add assignee
  const handleAssigneeAdd = (e) => {
    if (e.key === "Enter" && assigneeInput.trim() !== "") {
      e.preventDefault();

      const value = assigneeInput.trim();

      if (!assigneeList.includes(value)) {
        setAssigneeList([...assigneeList, value]);
      }

      setAssigneeInput("");
    }
  };

  // Remove assignee
  const handleAssigneeRemove = (index) => {
    const updatedList = assigneeList.filter((_, i) => i !== index);
    setAssigneeList(updatedList);
  };

//   tags
  const [tagList, setTagList] = useState(["Collab"]);
  const [tagInput, setTagInput] = useState("");

  // Add tag
  const handleTagAdd = (e) => {
    if (e.key === "Enter" && tagInput.trim() !== "") {
      e.preventDefault();

      const value = tagInput.trim();

      if (!tagList.includes(value)) {
        setTagList([...tagList, value]);
      }

      setTagInput("");
    }
  };

  // Remove tag
  const handleTagRemove = (index) => {
    const updatedList = tagList.filter((_, i) => i !== index);
    setTagList(updatedList);
  };

    const [followDate, setFollowDate] = useState(null);
  const followRef = useRef(null);
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="lg"
        className="deal-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Deals</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row>
            <Col md={6}>
              <Form.Label>Deal Name *</Form.Label>
              <Form.Select className="custom-select">
                <option>Select</option>
              </Form.Select>
            </Col>

            <Col md={6}>
              <Form.Label>Status *</Form.Label>
              <Form.Select className="custom-select">
                <option>Select</option>
              </Form.Select>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={6}>
              <div className="d-flex justify-content-between">
                <Form.Label>Pipeline *</Form.Label>
                <span onClick={() => setShowPipeline(true)} className="add-new">
                  + Add New
                </span>
              </div>
              <Form.Select className="custom-select">
                <option>Select</option>
              </Form.Select>
            </Col>

            <Col md={6}>
              <Form.Label>Currency *</Form.Label>
              <Form.Select className="custom-select">
                <option>Select</option>
              </Form.Select>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={6}>
              <Form.Label>Deal Value *</Form.Label>
              <Form.Control />
            </Col>

            <Col md={6}>
              <Form.Label>Period Value *</Form.Label>
              <Form.Control />
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={6}>
              <Form.Label>Period *</Form.Label>
              <Form.Select className="custom-select">
                <option>Select</option>
              </Form.Select>
            </Col>
            <Col md={6}>
              <Form.Label>Contact *</Form.Label>

              <div className="tags-box">
                {tags.map((tag, index) => (
                  <span key={index} className="tag">
                    {tag}
                    <button onClick={() => removeTag(index)}>✕</button>
                  </span>
                ))}

                <input
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  onKeyDown={handleKeyDown}
                  placeholder="Add new"
                />
              </div>
            </Col>
          </Row>

          <Form.Group className="mt-3">
            <Form.Label>Project *</Form.Label>

            <div className="tags-box">
              {projectList.map((item, index) => (
                <span key={index} className="tag">
                  {item}
                  <button
                    type="button"
                    onClick={() => handleProjectRemove(index)}
                  >
                    ✕
                  </button>
                </span>
              ))}

              <input
                type="text"
                placeholder="Add new"
                value={projectInput}
                onChange={(e) => setProjectInput(e.target.value)}
                onKeyDown={handleProjectAdd}
              />
            </div>
          </Form.Group>
    <Row className="mt-3">
  <Col xs={12} md={6}>
    <Form.Label>Due Date *</Form.Label>

    <div className="date-box">
      <DatePicker
        selected={dueDate}
        onChange={(date) => setDueDate(date)}
        placeholderText="dd/mm/yyyy"
        dateFormat="dd/MM/yyyy"
        className="form-control"
      />
      {/* <FiCalendar className="calendar-icon" /> */}
    </div>
  </Col>

  <Col xs={12} md={6}>
    <Form.Label>Expected Closing Date *</Form.Label>

    <div className="date-box">
      <DatePicker
        selected={closingDate}
        onChange={(date) => setClosingDate(date)}
        placeholderText="dd/mm/yyyy"
        dateFormat="dd/MM/yyyy"
        className="form-control"
      />
      {/* <FiCalendar className="calendar-icon" /> */}
    </div>
  </Col>
</Row>

     <Form.Group className="mt-3">
      <Form.Label>Assignee *</Form.Label>

      <div className="tags-box">
        {assigneeList.map((item, index) => (
          <span key={index} className="tag">
            {item}
            <button
              type="button"
              onClick={() => handleAssigneeRemove(index)}
            >
              ✕
            </button>
          </span>
        ))}

        <input
          type="text"
          placeholder="Add new"
          value={assigneeInput}
          onChange={(e) => setAssigneeInput(e.target.value)}
          onKeyDown={handleAssigneeAdd}
        />
      </div>
    </Form.Group>

          <Row className="mt-3">
        <Col md={6}>
      <Form.Label>Tags *</Form.Label>

      <div className="tags-box">
        {tagList.map((item, index) => (
          <span key={index} className="tag">
            {item}
            <button
              type="button"
              onClick={() => handleTagRemove(index)}
            >
              ✕
            </button>
          </span>
        ))}

        <input
          type="text"
          placeholder="Add new"
          value={tagInput}
          onChange={(e) => setTagInput(e.target.value)}
          onKeyDown={handleTagAdd}
        />
      </div>
    </Col>

      <Col md={6}>
      <Form.Label>Followup Date *</Form.Label>

      <div
        className="date-box"
        onClick={() => followRef.current.setOpen(true)}
      >
        <DatePicker
          selected={followDate}
          onChange={(date) => setFollowDate(date)}
          placeholderText="dd/mm/yyyy"
          dateFormat="dd/MM/yyyy"
          ref={followRef}
          className="form-control"
        />

        {/* <FiCalendar className="calendar-icon" /> */}
      </div>
    </Col>
          </Row>

          <Row className="mt-3">
            <Col md={6}>
              <Form.Label>Source *</Form.Label>
              <Form.Select className="custom-select">
                <option>Select</option>
              </Form.Select>
            </Col>

            <Col md={6}>
              <Form.Label>Priority *</Form.Label>
              <Form.Select className="custom-select">
                <option>Select</option>
              </Form.Select>
            </Col>
          </Row>

          <Form.Group className="mt-3">
            <Form.Label>Description *</Form.Label>
            <Form.Control as="textarea" rows={3} />
          </Form.Group>

          {/* FOOTER */}
          <div className="footer-actions">
            <Button variant="light" onClick={handleClose}>
              Cancel
            </Button>
            <Button className="btn-orange">Save</Button>
          </div>
        </Modal.Body>
        <EditPipelineModal
          show={showPipeline}
          handleClose={() => setShowPipeline(false)}
        />
      </Modal>

      {/* STYLES */}
      <style>{`
        .deal-modal .modal-content {
          border-radius: 10px;
        }

        .btn-orange {
          background:#ff6b2c;
          border:none;
          color:white;
        }

        .custom-select:focus {
          border-color:#ff6b2c;
          box-shadow:0 0 0 0.2rem rgba(255,107,44,0.2);
        }

        option:checked {
          background:#ff6b2c;
          color:white;
        }

        .date-box {
          position:relative;
        }

        .date-box svg {
          position:absolute;
          right:10px;
          top:10px;
        }

        .tags-box {
          display:flex;
          flex-wrap:wrap;
          gap:6px;
          border:1px solid #ddd;
          padding:6px;
          border-radius:6px;
        }

        .tags-box span {
          background:#e5e7eb;
          padding:4px 8px;
          border-radius:6px;
          font-size:12px;
        }

        .tags-box input {
          border:none;
          outline:none;
          flex:1;
        }

        .add-new {
          color:#ff6b2c;
          font-size:13px;
          cursor:pointer;
        }

        .footer-actions {
          display:flex;
          justify-content:flex-end;
          gap:10px;
          margin-top:20px;
        }

     //    contact
     .tags-box {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 6px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  min-height: 42px;
  align-items: center;
}

.tag {
  background: #f1f5f9;
  padding: 4px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  font-size: 13px;
}

.tag button {
  background: none;
  border: none;
  margin-left: 6px;
  cursor: pointer;
}

.tags-box input {
  border: none;
  outline: none;
  flex: 1;
  min-width: 100px;
}

/* dates */
.date-box {
  position: relative;
  width: 100%;
}

/* Input */
.date-box .form-control {
  width: 100%;
  padding-right: 40px;
}

/* Icon inside input (FIXED) */
.calendar-icon {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  font-size: 18px;
  color: #6b7280;
  pointer-events: none;
} prevents misalignment click issues */
}

// tags
.tags-box {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 6px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  min-height: 42px;
  align-items: center;
}

.tag {
  background: #f1f5f9;
  padding: 4px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  font-size: 13px;
}

.tag button {
  background: none;
  border: none;
  margin-left: 6px;
  cursor: pointer;
}

.tags-box input {
  border: none;
  outline: none;
  flex: 1;
  min-width: 120px;
}

// folloup data
.date-box {
  position: relative;
  width: 100%;
}

.date-box .form-control {
  width: 100%;
  padding-right: 40px;
  cursor: pointer;
}

.calendar-icon {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  font-size: 18px;
  color: #6b7280;
}

        @media(max-width:768px){
          .footer-actions {
            flex-direction:column;
          }
        }
      `}</style>
    </>
  );
};

export default EditLeadAddModal;
